import { Box, Typography } from '@mui/material';

const ContactExtra = ({ extra, ...params }) => {
    return (
        extra &&
        <Box {...params}>
            {Object.keys(extra).map((key) => (
                extra[key] &&
                    <Typography key={key} variant="body2" color="textSecondary">
                        {key.charAt(0).toUpperCase() + key.slice(1)} : {extra[key]}
                    </Typography>
            ))}
        </Box>
    );
};

export default ContactExtra;